export default "__VITE_ASSET__CBhrjhv6__"